export const SPECIALITES = [
  "Médecine générale",
  "Cardiologie",
  "Pneumologie",
  "Rhumatologie",
  "Neurologie",
  "Psychiatrie",
  "Médecine physique réadaptation",
  "Chirurgie générale",
  "Chirurgie orthopédique",
  "Chirurgie digestive",
  "Médecine du sport",
  "Médecine de la douleur",
  "Psychologue",
  "Autre"
];